'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from './useDecisions';
export const useSlaGroupingDecisions = () => {
  const $ = _c(2);
  const slaGrouping = useDecisions("ff_sla_grouping");
  let t0;
  if ($[0] !== slaGrouping) {
    t0 = {
      isSlaGroupingEnabled: slaGrouping
    };
    $[0] = slaGrouping;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};